<header class="header-container">
  <div class="left">
    <button class="back" (click)="navigateToPlatform()" data-testid="home-button" matRipple
      matRippleColor="var(--ripple)" askTooltip [askTooltipMessage]="'TOOLTIPS.OPEN_DASHBOARD' | translate">
      <img *ngIf="!(isScreenSmall$ | async)" src="assets/img/asksuite-logo-robot.svg" alt="asksuite logo" />
      <img *ngIf="(isScreenSmall$ | async)" [src]="smallLogoSrc" alt="asksuite logo" />
    </button>
    <div *ngIf="(isScreenSmall$ | async)" class="divider"></div>
    <h1 *ngIf="(isScreenSmall$ | async)" class="title">LiveChat 3.0</h1>
    <app-theme-toggle />
  @if(showKanban$ | async) {    
      <ask-button-v2
        appearance="opaque"
        size="small"
        [selected]="!!(isKanbanOpen$ | async)"
        (onClick)="toggleKanban()"
        data-testid="open-kanban-button"
      >
        <app-icon name="view_kanban" matFontSet="material-symbols-outlined" [size]="18" />
        <span>{{ 'KANBAN.MODE' | translate }}</span>
      </ask-button-v2>
    }
  </div>

  <div class="configuration-content">

    @if(showPhoneApp$ | async){
    <app-phone-toggle data-testid="app-phone-toggle" />
    }

    <app-spectator-mode></app-spectator-mode>

    <app-credits-balance-button />

    <app-notification-toggle />
    <div class="more-options" #dropdown1 (click)="getClass()" [askDropdown]="optionsDropdown">
      <ask-button-v2 id="moreOptions" [selected]="isSomeDropdownOpen" appearance="outline" size="medium" askTooltip
        [askTooltipMessage]="getTooltip()">
        <app-icon name="help" class="dropdown-icon" matFontSet="material-symbols-outlined"></app-icon>
      </ask-button-v2>
      @if(!isSomeDropdownOpen && numberNotification !== ''){
        <span [ngClass]="{'-isScreenSmall': (isScreenSmall$ | async)}" class="numberNotification">{{numberNotification}}</span>
      }
      <!--<app-notification-tooltip class="notification"></app-notification-tooltip>-->
    </div>
    <div class="user-container" [askDropdown]="userOptions" data-testid="profile-menu" (click)="onProfileMenuClick()">
      <div class="user" matRipple matRippleColor="var(--ripple)">
        <div class="avatar-wrapper">
          <ask-avatar [src]="avatar.image" [name]="avatar.name" background="dark" textColor="text-white" class="avatar">
          </ask-avatar>
          <span *ngIf="showNewMenu && statusSynced" class="avatar-status" [ngClass]="'avatar-status--' + currentStatus"></span>
        </div>
        <p *ngIf="(isScreenSmall$ | async)" class="name">{{ name }}</p>
        <i class="material-icons notranslate">expand_more</i>
      </div>
    </div>
  </div>
</header>

<ng-template #optionsDropdown>
  <form [formGroup]="filterForm" class="more-filters">
      <div class="option-list">
        <div class="header-options beamerTrigger">
          <app-icon name="hotel_class" matFontSet="material-symbols-outlined" ></app-icon>
          <label class="label-option"> {{'TOOLTIPS.NEWS' | translate}}</label>
          <span *ngIf="numberNotification !== ''" class="numberNotificationOption">{{numberNotification}}</span>
        </div>
        <a (click)="onHelpCenterClick()" class="header-options">
          <app-icon name="help" matFontSet="material-symbols-outlined" ></app-icon>
          <label class="label-option">{{'TOOLTIPS.HELP_CENTER' | translate}}</label>
        </a>
        <a (click)="onHelpFeedbackClick()" class="header-options">
          <app-icon name="flag_2" matFontSet="material-symbols-outlined" ></app-icon>
          <label class="label-option">{{"GIVE_FEEDBACK" | translate}}</label>
          <span class="newNotification">NEW</span>
        </a>
      </div>
  </form>
</ng-template>

<ng-template #userOptions>
  <div *ngIf="showNewMenu; else legacyUserOptions" class="user-dropdown" data-testid="dropdown">
    <div class="user-dropdown__header">
      <ask-avatar [src]="avatar.image" [name]="avatar.name" background="dark" textColor="text-white" size="small"></ask-avatar>
      <span class="user-dropdown__name">{{ name }}</span>
    </div>

    <div class="user-dropdown__section">
      <div 
        class="user-dropdown__menu-item user-dropdown__menu-item--has-submenu" 
        data-testid="status-menu-item"
        (mouseenter)="onSubmenuHover('status')"
        (mouseleave)="onSubmenuLeave('status')"
      >
        <span class="user-dropdown__label">{{ 'STATUS_LABEL' | translate }}</span>
        <div class="user-dropdown__right">
          <span *ngIf="!updatingStatus" class="user-dropdown__status-indicator" [class]="'user-dropdown__status-indicator--' + currentStatus"></span>
          <span *ngIf="!updatingStatus" class="user-dropdown__complement">{{ currentStatusLabel | uppercase }}</span>
          <span *ngIf="updatingStatus" class="user-dropdown__complement user-dropdown__complement--loading">{{ 'STATUS.UPDATING' | translate }}</span>
          <app-icon name="chevron_right" matFontSet="material-symbols-outlined" [size]="20"></app-icon>
        </div>
        <div class="user-dropdown__submenu" *ngIf="activeSubmenu === 'status'" (mouseenter)="onSubmenuHover('status')" (mouseleave)="onSubmenuLeave('status')">
          <div 
            *ngFor="let status of STATUS_OPTIONS" 
            class="user-dropdown__submenu-item"
            [class.user-dropdown__submenu-item--disabled]="updatingStatus"
            (click)="setStatus(status.value)"
          >
            <span class="user-dropdown__status-indicator" [class]="'user-dropdown__status-indicator--' + status.value"></span>
            <span class="user-dropdown__submenu-item-label">{{ status.label | translate }}</span>
            <app-spinner *ngIf="updatingStatus && pendingStatus === status.value" class="user-dropdown__status-spinner"></app-spinner>
            <app-icon *ngIf="!updatingStatus && currentStatus === status.value" name="check" matFontSet="material-symbols-outlined" [size]="20" class="user-dropdown__check-icon"></app-icon>
          </div>
        </div>
      </div>

      <div 
        class="user-dropdown__menu-item user-dropdown__menu-item--has-submenu" 
        data-testid="language-menu-item"
        (mouseenter)="onSubmenuHover('language')"
        (mouseleave)="onSubmenuLeave('language')"
      >
        <span class="user-dropdown__label">{{ 'LANGUAGE_LABEL' | translate }}</span>
        <div class="user-dropdown__right">
          <span class="user-dropdown__complement">{{ currentLanguageLabel | uppercase }}</span>
          <app-icon name="chevron_right" matFontSet="material-symbols-outlined" [size]="20"></app-icon>
        </div>
        <div class="user-dropdown__submenu" *ngIf="activeSubmenu === 'language'" (mouseenter)="onSubmenuHover('language')" (mouseleave)="onSubmenuLeave('language')">
          <div 
            *ngFor="let lang of LANGUAGES" 
            class="user-dropdown__submenu-item"
            (click)="setLanguage(lang.value)"
            data-testid="language-select"
          >
            <span class="user-dropdown__submenu-item-label">{{ lang.label }}</span>
            <app-icon *ngIf="filterForm.get('language')?.value?.value === lang.value" name="check" matFontSet="material-symbols-outlined" [size]="20" class="user-dropdown__check-icon"></app-icon>
          </div>
        </div>
      </div>

      <div 
        class="user-dropdown__menu-item user-dropdown__menu-item--has-submenu" 
        data-testid="theme-menu-item"
        (mouseenter)="onSubmenuHover('theme')"
        (mouseleave)="onSubmenuLeave('theme')"
      >
        <span class="user-dropdown__label">{{ 'THEME' | translate }}</span>
        <div class="user-dropdown__right">
          <span class="user-dropdown__complement">{{ theme === 'light' ? ('LIGHT' | translate | uppercase) : ('DARK' | translate | uppercase) }}</span>
          <app-icon name="chevron_right" matFontSet="material-symbols-outlined" [size]="20"></app-icon>
        </div>
        <div class="user-dropdown__submenu" *ngIf="activeSubmenu === 'theme'" (mouseenter)="onSubmenuHover('theme')" (mouseleave)="onSubmenuLeave('theme')">
          <div 
            class="user-dropdown__submenu-item"
            (click)="setTheme('light')"
          >
            <span class="user-dropdown__submenu-item-label">{{ 'LIGHT' | translate }}</span>
            <app-icon *ngIf="theme === 'light'" name="check" matFontSet="material-symbols-outlined" [size]="20" class="user-dropdown__check-icon"></app-icon>
          </div>
          <div 
            class="user-dropdown__submenu-item"
            (click)="setTheme('dark')"
          >
            <span class="user-dropdown__submenu-item-label">{{ 'DARK' | translate }}</span>
            <app-icon *ngIf="theme === 'dark'" name="check" matFontSet="material-symbols-outlined" [size]="20" class="user-dropdown__check-icon"></app-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="user-dropdown__section user-dropdown__section--bordered">
      <div class="user-dropdown__menu-item beamerTrigger" data-testid="news-menu-item">
        <app-icon name="hotel_class" matFontSet="material-symbols-outlined" [size]="20"></app-icon>
        <span class="user-dropdown__label">{{ 'TOOLTIPS.NEWS' | translate }}</span>
        <span *ngIf="numberNotification !== ''" class="user-dropdown__badge">{{ numberNotification }}</span>
      </div>

      <div class="user-dropdown__menu-item" (click)="onHelpCenterClick()" data-testid="help-center-menu-item">
        <app-icon name="help" matFontSet="material-symbols-outlined" [size]="20"></app-icon>
        <span class="user-dropdown__label">{{ 'TOOLTIPS.HELP_CENTER' | translate }}</span>
      </div>

      <div class="user-dropdown__menu-item" (click)="onHelpFeedbackClick()" data-testid="feedback-menu-item">
        <app-icon name="flag_2" matFontSet="material-symbols-outlined" [size]="20"></app-icon>
        <span class="user-dropdown__label">{{ 'GIVE_FEEDBACK' | translate }}</span>
      </div>
    </div>

    <div class="user-dropdown__section user-dropdown__section--bordered">
      <div class="user-dropdown__menu-item" (click)="navigateToSettings()" data-testid="settings-menu-item">
        <span class="user-dropdown__label">{{ 'GO_TO_SETTINGS' | translate }}</span>
        <div class="user-dropdown__right">
          <app-icon name="open_in_new" matFontSet="material-symbols-outlined" [size]="20"></app-icon>
        </div>
      </div>

      <div class="user-dropdown__menu-item" data-testid="dropdown-exit-button" (click)="exitSession()">
        <span class="user-dropdown__label">{{ 'EXIT' | translate }}</span>
      </div>
    </div>

    <p class="user-dropdown__version" data-testid="version">
      <small>{{ version }}</small>
    </p>
  </div>
</ng-template>

<ng-template #legacyUserOptions>
  <form [formGroup]="filterForm" class="more-filters">
    <div class="dropdown-block" data-testid="dropdown">
      <h1 class="greetings">{{ "GREETINGS" | translate }}, {{ firstName }}</h1>
      <div class="options-user">
        <ask-select data-testid="language-select" (valueChange)="setLanguage($event)"
          [selectAnOptionLabel]="'SELECT_AN_OPTION' | translate" [noOptionLabel]="'NO_OPTION' | translate"
          [noneLabel]="'NONE' | translate" class="language" [options]="LANGUAGES" [showNoneOption]="false"
          formControlName="language"></ask-select>
        <p class="exit" data-testid="dropdown-exit-button" (click)="exitSession()">
          {{ "EXIT" | translate }}
        </p>
      </div>
      <p class="version" data-testid="version">
        <small>{{version}}</small>
      </p>
    </div>
  </form>
</ng-template>

